import { Pipe, PipeTransform } from '@angular/core';

import { parseDate } from '../workflow-log.mapper';

const MOSCOW_TIME_FORMATTER = new Intl.DateTimeFormat('ru-RU', {
  timeZone: 'Europe/Moscow',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

@Pipe({
  name: 'moscowTime',
  standalone: true,
})
export class MoscowTimePipe implements PipeTransform {
  public transform(value: string | Date): string {
    const date = parseDate(value);

    return date ? MOSCOW_TIME_FORMATTER.format(date) : '--:--:--';
  }
}
